import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";
import { ITournament } from "redux/reducers/models/tournament";
import { IFacility } from "redux/reducers/models/facility";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";

import "./Tournament.scss";
import { GetTournament } from "api/rpc/2024-04/facilityAdmin/tournament/tournament";
import { GetFacility } from "api/rpc/2024-04/facilityAdmin/facility/facility";

interface ITournamentState {
  tournament: ITournament;
  facility: IFacility;
  tee_sheet_note: string;
}

export default function Tournament() {
  const { tournamentId } = useParams<{ tournamentId: string }>();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [state, setState] = useState<ITournamentState>({
    tournament: undefined,
    facility: undefined,
    tee_sheet_note: "",
  });

  useEffect(() => {
    void loadTournament();
  }, []);

  async function loadTournament() {
    const numericTournamentId = Number(tournamentId);
    const tournamentRes = await GetTournament({ id: numericTournamentId }, false);

    if (tournamentRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tournament.tournament.001")));
      return;
    }

    const tournament = tournamentRes.data[0];

    setState(prevState => ({
      ...prevState,
      tournament,
      tee_sheet_note: tournament?.tee_sheet_note ? tournament?.tee_sheet_note : "",
    }));

    const facilityRes = await GetFacility({ id: tournament.facility_id }, true);

    if (facilityRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tournament.tournament.002")));
      return;
    }

    const facility = facilityRes.data?.[0];

    if (facilityRes.status === StatusCode.OK) {
      setState(prevState => ({
        ...prevState,
        facility,
      }));
    }
  }

  return state.tournament ? (
    <Page title={state.tournament.name}
      narrow
      breadcrumbs={[
        {
          prefix: true,
          label: t("Tournaments"),
          url: "/admin/events-tournament",
        },
      ]}
    >
      {state.facility && <></>}
    </Page>
  ) : (
    <div />
  );
}
